import React from 'react';
import { Grid } from '@nextiva/next-ui-components';

const headerStyle = {
  width: '100%',
};

export const ShadowDom = () => {
  return (
    <div style={headerStyle}>
      <div className="m-shadow-team-list">
        <div className="m-shadow-team-list__header">
          <Grid container>
            <Grid item xs={4}>
              <div className="m-shadow-team-list__header__field" />
            </Grid>
            <Grid item xs={4}>
              <div className="m-shadow-team-list__header__field" />
            </Grid>
            <Grid item xs={4}>
              <div className="m-shadow-team-list__header__field" />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};
